import React, { useRef, useEffect, useState, useContext } from 'react';
import styles from './../../styles/form.module.css';
import { useForm } from 'react-hook-form';
import { getRoute } from './../../helpers/utils';
import { forgotPasswordOptions, defaultValues } from './options';
import {
  AlertConfig,
  FORGOT_PASSWORD,
  LOGIN,
  ON_CHANGE,
} from './../../content/constants';
import {
  Info,
  FormHeader,
  Logo,
  InputField,
  Button,
  NavigateLink,
  AlertBox
} from './../../components';
import auth0 from 'auth0-js';
import { useTranslation } from 'react-i18next';
import AuthContext from '../../context/AuthContext';
const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [captchaError, setCaptchaError] = useState('');
  const [isSubmitting, setSubmitting] = useState(false);
  const { data } = useContext(AuthContext);
  const logoUrl = data.tenantDetail?.logo || null;
  const params = data.params;
  var captcha;
  if (params) {
    var webAuth = new auth0.WebAuth(params);
    captcha = webAuth.renderCaptcha(
      document.querySelector('.captcha-container')
    );
  }
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue
  } = useForm({
    mode: ON_CHANGE
  });
  useEffect(() => {
    document.title = t('forgot_password_page_title');
  });
  const alertRef = useRef();

  const forgotPasswordCallback = (email, err) => {
    setSubmitting(false);
    if (err) {
      console.error(err.message);
    } else {
      setEmail(email);
      alertRef.current.showAlert(AlertConfig.RESET_LINK);
      window.grecaptcha.reset();
      for (const key in defaultValues) {
        setValue(key, defaultValues[key]);
      }
    }
  };
  const onSubmit = async (data) => {
    if(!captcha.getValue()) {
      setCaptchaError(forgotPasswordOptions.captcha.required);
      return;
    };
    setCaptchaError('');
    setSubmitting(true);
    var auth0Client = new auth0.WebAuth(params);
    auth0Client.changePassword(
      {
        connection: params?.connection,
        email: data?.email
      },
      forgotPasswordCallback.bind(this, data.email)
    );
  };

  return (
    <div className={`${styles.auth_wrapper} ${
      logoUrl ? styles.auth_align_center : ''
    }`}>
      <div className={styles.logo}>
        <Logo logoUrl={logoUrl} />
      </div>
      {!logoUrl ? <Info logoUrl={logoUrl} /> : <div></div>}
      <div className={styles.form_container}>
        <AlertBox ref={alertRef} email={email} />
        <form onSubmit={handleSubmit(onSubmit)} className={styles.w_90}>
          <div className={styles.form_content}>
            <FormHeader
              heading={t('forgot_your_password')}
              subHeading={t('reset_password_description')}
            />
            <InputField
              label={t('email')}
              placeholder={t('enter_email_address')}
              type="email"
              id="email"
              customClassName={errors?.email?.message ? 'error' : ''}
              register={register('email', forgotPasswordOptions.email)}
              data-testid="forgot-password-email-address-input-field"
            />
            <span className={styles.err_text}>{t(errors?.email?.message)}</span>
            
            <div className="captcha-container"></div>
            {!!captchaError && (
              <span className={styles.err_text}>
                {t(captchaError)}
              </span>
            )}

            <Button
              showSpinner={isSubmitting}
              label={t('send')}
              type="submit"
              data-testid="forgot-password-submit-button"
            />
            <div className={styles.navigator}>
              <NavigateLink
                linkText={t('return_to_log_in')}
                linkUrl={getRoute(FORGOT_PASSWORD, LOGIN)}
                data-testid="forgot-password-login-link"
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
